import type { ProductFullDetails } from '@/api/product/getProductDetails.types';
import { PatientPrescriptionStatus } from '@montugroup/pms-api-contracts';

export const getCancelledOrDeletedStatus = (orderCode: string | null) => {
  if (!orderCode) {
    return PatientPrescriptionStatus.Deleted;
  }

  return orderCode.startsWith('ALEPS') ? PatientPrescriptionStatus.Cancelled : PatientPrescriptionStatus.Deleted;
};

export const showNotificationForProductSelection = (product: ProductFullDetails) => {
  const {
    is_out_of_stock: isOutOfStock,
    reasoning_toggle: reasoningToggle,
    is_excluded_from_new_prescriptions: isExcludedFromNewPrescriptions,
    is_generative_scripting: isGenerativeScripting,
    is_supply_chain_risk: isSupplyChainRisk
  } = product;
  return (
    isOutOfStock || reasoningToggle || isExcludedFromNewPrescriptions || isGenerativeScripting || isSupplyChainRisk
  );
};

// Product with is_out_of_stock flag true can be selected by doctor based on stock return date.
// Hence, we don't disable the products with is_out_of_stock flag.
export const isProductUnAvailableForSelection = (product: ProductFullDetails) => {
  const {
    reasoning_toggle: reasoningToggle,
    is_excluded_from_new_prescriptions: isExcludedFromNewPrescriptions,
    is_generative_scripting: isGenerativeScripting,
    is_supply_chain_risk: isSupplyChainRisk
  } = product;
  return reasoningToggle || isExcludedFromNewPrescriptions || isGenerativeScripting || isSupplyChainRisk;
};
